module.exports = __webpack_public_path__ + "img/liucheng.20df5279.png";